import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { UserProvider } from "./componentes/GestionDeUsuarios/UserContext";
import KyeToast from "./componentes/common/KyeToast";
import KyeConfirm from "./componentes/common/KyeConfirm";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <App />
        <KyeToast />
        <KyeConfirm />
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
);
